import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ALIGN_TITLE, PrivateDialogData} from './dialog.service';

interface Context<T> {
    close: (result?: any) => void;
    data: T;
}

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss']
})
export class DialogComponent<T> {

    constructor(private readonly dialogRef: MatDialogRef<DialogComponent<T>>,
                @Inject(MAT_DIALOG_DATA) readonly data: PrivateDialogData<T>) {
    }

    get context(): Context<T> & { $implicit: T } {
        return {
            close: this.close.bind(this),
            data: this.data.context,
            $implicit: this.data.context
        };
    }

    close(result?: any) {
        this.dialogRef.close(result);
    }

    setAlignClass(alignTitle: ALIGN_TITLE) {
        switch (alignTitle) {
            case ALIGN_TITLE.LEFT:
                return ALIGN_TITLE.LEFT;
            case ALIGN_TITLE.RIGHT:
                return ALIGN_TITLE.RIGHT;
            case ALIGN_TITLE.CENTER:
                return ALIGN_TITLE.CENTER;
            default:
                return '';
        }
    }
}
